import axios from "axios";
import { Message, MessageBox, Loading, Dialog, Input, Button } from "element-ui";
import { getToken, removeToken, removeLoginUser } from "@/utils/auth";
import store from "../store/store";
import Vue from "vue";
Vue.use(Loading.directive);
Vue.use(Dialog);
Vue.use(Input);
Vue.use(Button);
// 创建一个全局的Promise控制器来处理验证码验证流程
let captchaPromiseController = null;
// 创建验证码弹框组件
const CaptchaDialog = Vue.extend({
  render(h) {
    return h('el-dialog', {
      props: {
        title: '请输入验证码',
        visible: this.visible,
        closeOnClickModal: false,
        showClose: false,
        width: '30%'
      },
      on: {
        'update:visible': (val) => {
          this.visible = val;
        }
      }
    }, [
      h('div', { class: 'captcha-container' }, [
        h('el-input', {
          ref: 'captchaInput',
          props: {
            value: this.captcha,
            placeholder: '请输入邮箱收到的验证码',
            maxlength: 6
          },
          on: {
            input: (val) => {
              this.captcha = val;
            },
            'keyup-enter': this.handleConfirm
          }
        }),
        h('div', { class: 'send-btn-container' }, [
          h('el-button', {
            props: {
              type: 'text',
              disabled: this.counting,
              loading: this.sending
            },
            on: {
              click: this.sendCaptcha
            }
          }, this.counting ? `${this.countDown}秒后可以重新发送` : '重新获取验证码')
        ])
      ]),
      h('div', { slot: 'footer', class: 'dialog-footer' }, [
        h('el-button', {
          on: {
            click: this.handleCancel
          }
        }, '取消'),
        h('el-button', {
          props: {
            type: 'primary'
          },
          on: {
            click: this.handleConfirm
          }
        }, '确认')
      ])
    ]);
  },
  data() {
    const COUNTDOWN_TIME = 60;
    return {
      visible: false,
      captcha: "",
      counting: false,
      countDown: COUNTDOWN_TIME,
      sending: false,
      retryConfig: null,
      timer: null,
      COUNTDOWN_TIME
    };
  },
  methods: {
    // 显示弹框并记录需要重试的请求
    show(config) {
      this.visible = true;
      this.retryConfig = config;
      this.captcha = "";
      
      // 使用setTimeout替代nextTick确保DOM已经渲染
      setTimeout(() => {
        if (this.$refs.captchaInput && typeof this.$refs.captchaInput.focus === 'function') {
          this.$refs.captchaInput.focus();
        }
      }, 100);
      
      // 只有在不是倒计时状态下才自动发送验证码
      if (!this.counting) {
        this.sendCaptcha();
      }
    },

    // 发送验证码到邮箱
    sendCaptcha() {
      if (this.sending) return; // 防止重复点击
      this.sending = true;

      store.dispatch("sendSetIpWhiteListSmsUniqueCode")
        .then(res => {
          this.setSending(false);
          if (res && (res.code === 0 || res.code === "0")) {
            Message.success("验证码已发送到您的邮箱，请查收");
            this.startCountDown();
          } else {
            Message.error((res && res.message) || "发送验证码失败");
          }
        })
        .catch(err => {
          this.setSending(false);
          // Message.error("发送验证码失败，请稍后重试");
          // console.error("发送验证码错误:", err);
        });
    },

    setSending(status) {
      this.sending = status;
    },

    // 开始倒计时
    startCountDown() {
      this.clearTimer(); // 清除之前的定时器
      this.counting = true;
      this.countDown = this.COUNTDOWN_TIME;
      this.timer = setInterval(() => {
        this.countDown--;
        if (this.countDown <= 0) {
          this.clearTimer();
          this.counting = false;
        }
      }, 1000);
    },

    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },

    // 确认输入验证码
    handleConfirm() {
      if (!this.captcha.trim()) {
        Message.warning("请输入验证码");
        return;
      }

      if (!/^\d{6}$/.test(this.captcha)) {
        Message.warning("请输入6位数字验证码");
        return;
      }

      if (!this.retryConfig) {
        Message.error("请求参数丢失，请刷新页面重试");
        return;
      }

      // 验证验证码
      store.dispatch("checkSetIpWhiteListSmsUniqueCode", {
        smsCode: this.captcha,
      })
        .then(() => {
          // 验证成功后重试原始请求
          return service(this.retryConfig);
        })
        .then(response => {
          this.visible = false;
          Message.success("验证成功");
          
          // 解决原始Promise并传递响应数据
          if (captchaPromiseController) {
            captchaPromiseController.resolve(response);
            captchaPromiseController = null;
          }
        })
        .catch(err => {
          if (err && err.code === "-888") {
            // Message.error("验证码错误，请重新输入");
          } else {
            // Message.error((err && err.message) || "验证失败");
            // this.visible = false;
            
            // 拒绝原始Promise
            if (captchaPromiseController) {
              captchaPromiseController.reject(err);
              captchaPromiseController = null;
            }
          }
        });
    },

    // 取消
    handleCancel() {
      this.visible = false;
      this.clearTimer();
      this.counting = false;
      
      // 拒绝原始Promise
      if (captchaPromiseController) {
        captchaPromiseController.reject(new Error('用户取消验证码验证'));
        captchaPromiseController = null;
      }
    }
  },
  beforeDestroy() {
    this.clearTimer();
  }
});

// 实例化验证码弹框
const captchaDialog = new CaptchaDialog().$mount(document.createElement("div"));
document.body.appendChild(captchaDialog.$el);

let suffix = ["appg", "backg", "appnext"];

const backFix = suffix[1];

export const server = {
  // 服务项目后台接口
  service: {
    prod: "https://hx.hemiao100.com/" + backFix,
    sync: "https://sync.hemiao100.com/backg",
    gaoli: "http://192.168.188.161:6060",
    zjh66: "http://192.168.88.66/backg",
    wanglicheng: "http://192.168.88.102:6060",
    fangxiang: "http://192.168.188.83:6060",
    test: "https://hexin.hemiao100.com/backg",
    test4: "http://192.168.88.15/backg", // 现在的测试
    test3: "https://hxweb.hemiao100.com/sync",
    chenjian: "http://192.168.188.80:6060",
    labelAddressDev: "http://192.168.188.80:6060",
    labelAddressTest: "http://192.168.188.80:6060",
    labelAddressProd: "https://hx.hemiao100.com/" + backFix,
    zyh: "http://192.168.88.156/backg",
    test157: 'http://192.168.88.157/supplier',
  }
};
let address;
if (process.env.NODE_ENV === "production") {
  const isTestServer = window.location.host.includes("hexin");
  // 线上地址
  address = isTestServer ? server.service.test : server.service.prod;
} else {
  // 本地调试地址
  address = server.service.test4;
}

// Vue.prototype.$uploadUrl = `https://hx.hemiao100.com/${backFix}/sys/common/upload/oss`;
Vue.prototype.$uploadUrl = `${address}/sys/common/upload/oss/with_record`;
Vue.prototype.$uploadCdnUrl = `${address}/sys/common/upload/oss/with_record_compress`;
Vue.prototype.$uploadVideoUrl = `${address}/sys/common/upload/oss/video`;
const wsAddress = address
  .replace("http://", "wss://")
  .replace("https://", "wss://");
Vue.prototype.$wsAddress = `${wsAddress}/websocket`;

Vue.prototype.$serverAdress = address;
// 创建axios实例
const service = axios.create({
  baseURL: address, // api 的 base_url
  timeout: 1000 * 60 // 请求超时时间
});

let loading;

// 增加一个 loadingRequestCount 变量，用来计算请求的次数。
var loadingRequestCount = 0;

// request拦截器

service.interceptors.request.use(
  config => {
    loadingRequestCount++;
    let flag =
      config.url.length > 0
        ? config.url.substring(config.url.indexOf("?")).substr(1)
        : "";
    if (
      config.url.indexOf("store/ssrBasicConfig/addSsrAnalysisQueue") < 1 &&
      flag !== "false"
    ) {
      loading = Loading.service({
        lock: true,
        text: "卖力加载中",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0)"
      });
    }

    if (flag === "false") {
      loading.close();
    }

    if (config.method === "get") {
      config.params = {
        _t: Date.parse(new Date()) / 1000,
        ...config.params
      };
    }

    if (config.url.includes("/sys/permission/getUserPermissionByToken")) {
      config.data = config.params || {};
    }

    if (store.getters.token) {
      config.headers["X-Access-Token"] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config;
  },
  error => {
    loading.close();
    loadingRequestCount = 0;

    // Do something with request error

    Promise.reject(error);
  }
);

// response 拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非0是抛错 可结合自己业务进行修改
     */
    Vue.prototype.$failure = true;
    const res = response.data;

    // console.warn(response.headers);
    // let flag = false;
    // for (let key in response.headers) {
    //   if (response.headers[key] === "application/octet-stream") {
    //     flag = true;
    //   }
    // }
    loadingRequestCount--;
    if (loadingRequestCount < 0) {
      loadingRequestCount = 0;
    }
    if (
      res.code !== "0" &&
      res.code !== 0 &&
      res.code !== 200 &&
      res.code !== 0
    ) {
      if (loadingRequestCount == 0) {
        loading.close();
      }
      // if (flag) {
      //   return response.data;
      // } else {
      if (res.code === "9999" || res.code === "-555" || res.code === "-666" || res.code === "-777") {
        MessageBox.alert(res.outMsg || res.message || res.errMsg, "", {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "关闭",
          type: "error"
        });
      }else if(res.code === "-888") {
        // 显示验证码弹框并传入当前请求配置
        captchaDialog.show(response.config);
        
        // 创建并返回一个新的Promise，等待用户完成验证码验证
        return new Promise((resolve, reject) => {
          captchaPromiseController = { resolve, reject };
        });
      }  else {
        Message({
          message: res.outMsg || res.message || res.errMsg,
          type: "error",
          duration: 5 * 1000
        });
      }

      console.log("res: ", res);
      return Promise.reject(res);
      // }
    } else {
      if (loadingRequestCount == 0) {
        loading.close();
      }

      return response.data;
    }
  },
  error => {
    if (error.response) {
      Vue.prototype.$failure = false;
      let data = error.response.data;
      const token = getToken();
      switch (error.response.status) {
        case 403:
          Message({
            message: "拒绝访问",
            type: "error",
            duration: 5 * 1000
          });
          break;
        case 500:
          //Message.error({ message: '系统提示', description:'Token失效，请重新登录!',duration: 4})
          if (
            token &&
            data.message === "Token失效，请重新登录" &&
            !window.location.pathname.includes("individualRanking") &&
            !window.location.pathname.includes("overseasGoodsDetail")
          ) {
            // update-begin- --- author:scott ------ date:20190225 ---- for:Token失效采用弹框模式，不直接跳转----
            MessageBox.confirm("登录已过期，请重新登录", "确定登出", {
              confirmButtonText: "重新登录",
              cancelButtonText: "取消",
              type: "warning"
            }).then(() => {
              removeToken();
              removeLoginUser();
              window.location.href = window.location.origin;
              // location.reload();
              // router.push({ name: "login" });
              // store.dispatch("LogOut").then(() => {
              //   removeToken();
              //   removeLoginUser();
              //   location.reload(); // 为了重新实例化vue-router对象 避免bug
              // });
            });
            // update-end- --- author:scott ------ date:20190225 ---- for:Token失效采用弹框模式，不直接跳转----
          }
          break;
        case 404:
          Message({
            message: "很抱歉，资源未找到",
            type: "error",
            duration: 5 * 1000
          });
          break;
        case 504:
          Message({
            message: "网络超时",
            type: "error",
            duration: 5 * 1000
          });
          break;
        case 401:
          Message({
            message: "未授权，请重新登录",
            type: "error",
            duration: 5 * 1000
          });
          if (token) {
            store.dispatch("Logout").then(() => {
              removeToken();
              removeLoginUser();
              setTimeout(() => {
                window.location.reload();
              }, 1500);
            });
          }
          break;
        default:
          Message({
            message: data.message,
            type: "error",
            duration: 5 * 1000
          });
          break;
      }
    }
    loading.close();
    loadingRequestCount = 0;

    return Promise.reject(error);
  }
);

export const request = service;
